import { useCallback } from 'react'
import {
	getListBookingRequestsQueryKey,
	useCancelBookingRequest,
} from '@cocoonspace/sdk-js/v2/domains/schedulers/schedulers'
import { BookingRequest } from '@cocoonspace/sdk-js/v2/types/bookingRequest'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@cocoonspace/ui/components/alert-dialog'
import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2Icon } from 'lucide-react'
import { toast } from 'sonner'

export const DeleteBookingRequestDialog = ({
	bookingRequest,
}: {
	bookingRequest: BookingRequest
}) => {
	const queryClient = useQueryClient()
	const { t } = useLingui()

	const { mutateAsync: cancelMutation } = useCancelBookingRequest()

	const deleteBookingRequest = useCallback(() => {
		return cancelMutation({ bookingRequestId: bookingRequest.id })
			.then(() => {
				const queryKey = getListBookingRequestsQueryKey()
				queryClient.invalidateQueries({ queryKey })

				toast.success(t`Demande de rendez-vous annulée`)
			})
			.catch(() => {
				toast.error(t`Erreur lors de l'annulation de la demande de rendez-vous`)
			})
	}, [cancelMutation, bookingRequest.id, t, queryClient])

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button
					variant='ghost'
					size='sm'
					className='flex-1'
				>
					<Trash2Icon /> {t`Annuler`}
				</Button>
			</AlertDialogTrigger>

			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{t`Annuler la demande de rendez-vous`}</AlertDialogTitle>
				</AlertDialogHeader>

				<AlertDialogDescription>
					{t`Etes-vous sûr de vouloir annuler cette demande de rendez-vous ?`}
				</AlertDialogDescription>

				<AlertDialogFooter>
					<AlertDialogCancel>{t`Ne pas annuler`}</AlertDialogCancel>

					<AlertDialogAction onClick={() => deleteBookingRequest()}>
						{t`Annuler la demande`}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
